import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { jsx as _jsx } from "react/jsx-runtime";
/*global $*/

import React from "react";
import { assert } from "@/common/assert";
import jqueryDataUtil from "@/common/jqueryDataUtil"; //refer to http://lbsyun.baidu.com/index.php?title=jspopular3.0

var BDMap =
/** @class */
function (_super) {
  __extends(BDMap, _super);

  function BDMap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.myRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  BDMap.prototype.componentDidMount = function () {
    assert(BMap, "BMap falsy, make sure you loaded baidu map's script");
    var el = this.myRef.current;
    var map = new BMap.Map(el);
    var $map = $(el);
    var longitude = jqueryDataUtil.requiredNumber($map, "geo-long");
    var latitude = jqueryDataUtil.requiredNumber($map, "geo-lat");
    var point = new BMap.Point(longitude, latitude);
    var ZOOM_LEVEL = 10;
    var location = this.props.message.location;
    map.centerAndZoom(point, ZOOM_LEVEL);
    map.addControl(new BMap.MapTypeControl({
      mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
    }));
    map.addControl(new BMap.NavigationControl());
    var opts = {
      title: "地址：",
      width: 200,
      height: 60 // 信息窗口高度

    };
    var infoWindow = new BMap.InfoWindow(location, opts); // 创建信息窗口对象

    map.openInfoWindow(infoWindow, point); //开启信息窗口

    var marker = new BMap.Marker(point);
    marker.addEventListener("click", function () {
      map.openInfoWindow(infoWindow, point); //开启信息窗口
    });
    map.addOverlay(marker);
  };

  BDMap.prototype.render = function () {
    return _jsx("div", {
      ref: this.myRef,
      className: "map-container",
      "data-geo-lat": this.props.message.latitude,
      "data-geo-long": this.props.message.longitude
    }, void 0);
  };

  return BDMap;
}(React.Component);

export default BDMap;